// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
// COMPONENTS
import { Route, Redirect } from 'react-router-dom';
// CUSTOM COMPONENTS
import HeaderBlock from '../components/HeaderBlock';
import Drawer from '../components/Drawer';
import ListContainer from '../components/ListContainer';
import ListItem from './ListItem';
import CustomBlock from './CustomBlock';
import Button from './Button';
// SERVICES AND HELPERS
import * as helper from '../helpers/helper'

export const PrivateRoute = ({ component: Component, ...rest }) => {

    const [drawerOpen, setDrawerOpen] = useState(false);
    const body = document.querySelector('body');

    const menuItems = [
        { id: 1, name: "Dashboard", navigation: "/dashboard" },
        { id: 2, name: "Start New Campaign", navigation: "/new-campaign" },
        // { id: 3, name: "Campaign Summary", navigation: "/campaign-summary" },
        // { id: 3, name: "View All Quotes", navigation: "/quotes" },
        // { id: 4, name: "View Media Types", navigation: "/media-types" },
        // { id: 5, name: "View Categories", navigation: "/categories" },
        // { id: 6, name: "View Products", navigation: "/products" },
        // { id: 7, name: "View Companies", navigation: "/companies" },
        // { id: 8, name: "View Users", navigation: "/users" },
        // { id: 8, name: "View Sales Tools", navigation: "/sales-tools" },
    ]

    const closeDrawer = () => {
        setTimeout(() => {
            setDrawerOpen(false);
            enableBodyScroll(body);
        }, 250)
    }

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
        if (!drawerOpen) {
            disableBodyScroll(body);
        } else {
            setTimeout(() => {
                enableBodyScroll(body);
            }, 500);
        }
    }

    return (
        <Route {...rest} render={props => {
            const isAuthenticated = helper.IsUserLoggedIn();

            if (isAuthenticated) {
                return (
                    <>
                        <HeaderBlock
                            title={rest.title}
                            backgroundColor={rest.title === "Quote" ? "lighter--bg" : "white--bg"}
                            toLeft="/dashboard"
                            onClickRight={() => toggleDrawer()}
                        />
                        <Component {...props} />
                        <Drawer
                            title="Navigation"
                            position="right"
                            open={drawerOpen}
                            onClick={() => toggleDrawer()}
                            closeOnMaskPress
                        >
                            <ListContainer className="drawer-links-container">
                                {
                                    menuItems.map((menu, index) =>
                                        <ListItem
                                            title={menu.name}
                                            to={menu.navigation}
                                            className="drawer-links"
                                            onClick={() => closeDrawer()}
                                        />
                                    )
                                }
                            </ListContainer>

                            <CustomBlock className="padding-horizontal">
                                <Button
                                    text="Sign Out"
                                    className="drawer-button"
                                    onClick={() => localStorage.removeItem('user')}
                                />
                            </CustomBlock>
                        </Drawer>
                    </>
                )
            }

            return <Redirect to="/" />
        }} />
    );
}